/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { NavLink, useLocation, useParams } from 'react-router-dom';
import { type FC } from 'react';

import { I18n } from '@coze-arch/i18n';
import { getAbrDevelopHomePath } from '@coze-studio/abr-brand';

const getSpaceIdFromPath = (pathname: string): string | undefined => {
  const match = pathname.match(/\/space\/([^/]+)/);
  return match?.[1];
};

export const TryNewVersionBanner: FC = () => {
  const { pathname } = useLocation();
  const { space_id: spaceIdFromParams } = useParams();
  const spaceId = spaceIdFromParams || getSpaceIdFromPath(pathname);

  const to = spaceId ? getAbrDevelopHomePath(spaceId) : '/space';

  return (
    <div className="h-[30px] flex items-center justify-end px-[16px] bg-[#e6f4ff] border-b border-solid border-[#91caff]">
      <NavLink
        to={to}
        className="text-[12px] font-medium text-[#1677ff] no-underline hover:underline"
        data-testid="layout_try-new-version-link"
      >
        {I18n.t('abr_shell_try_new_version')}
      </NavLink>
    </div>
  );
};
